// extracted by mini-css-extract-plugin
export default {"tags":"TagList-tags-AT8ST"};